<template lang="html">
  <footer v-if="$route.name === 'Login'" class="uk-container uk-width uk-flex uk-flex-wrap uk-flex-end uk-flex">
    <div class="uk-width uk-text-center" v-text="config.footer_text"></div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {}
  },
  computed: {
    config () {
      return this.$parent.config
    }
  }
}
</script>

<style lang="sass" scoped>

  footer
    height: 55px
    max-width: 960px
    font-weight: 200
    font-size: 12px
    text-align: justify
    padding: 0

    @media screen and (max-width: 960px)
      > div
        width: 100%
        margin-top: 10px
        text-align: center
      padding-left: 10px
      padding-right: 10px


</style>



// WEBPACK FOOTER //
// app-footer.vue?3f81eb60